import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { ConsultaProdutos } from "../funcionalidades/bancoGet";
import GlobalVar from "./GlobalVar";

const ColorCircle = ({item, bg, dispachInfo, stateInfo})=>{
    return <div className="circleBtn">
        <div className={`seletorCircle ${stateInfo.produtoPaginaSelectedInfo.color.label ==  item.label ? 'selected' :  ''}`}>


              <div
                  key={item.label}
                  className="colorCircleUnique"
                  loading="lazy"
                  style={
                  !item.isCorDaFoto && item.isHexColor
                      ? { backgroundColor: item.corOuImagem }
                      : { background: /*`${bg} no-repeat top/cover`*/ '#000000' }
                  }
                  onClick={()=>{
                      dispachInfo({type: 'produtoPaginaSelectedInfo', value: {...GlobalVar.destructObj(stateInfo.produtoPaginaSelectedInfo), color: {label: item.label, hex: item.corOuImagem}}})
                  }}
              />
        </div>
              <div className="namecolor">{item.label === 'Cor da Foto' ? 'PRETO' : item.label}</div>
      </div>
}

export const ProdutoPagina = ({showStyle, dispachInfo, stateInfo})=>{

    const prod = stateInfo.produtoPagina
    const estampasObj = parseTamanhosEstampasToObject(prod.tamanhos_estampas)
    const estampasOrdenadas = ordenarEstampasObject(estampasObj)
    const urlImage = `https://apirevendedoratime.babita.com.br/images/${prod.cod_ref}.jpg`

    const [bg, setBg] = useState('#FFF');
    
      useEffect(() => {
          //console.log("TESTE IMAGE")
        const img = new Image();
        img.src = urlImage;
    
        img.onload = () => {
          setBg(`url('${urlImage}')`);
        };
    
        img.onerror = () => {
          setBg(`url('https://apifornecedores.babita.com.br/images/publicImages/ImagemNaoEncontrada.jpg')`);
        };
      }, [urlImage]);

      useEffect(() => {
        if (showStyle && ConsultaProdutos) {
        dispachInfo({type: 'produtoPaginaSelectedInfo', 
            value: {color: {label: Object.keys(estampasObj)[0], hex: estampasObj[Object.keys(estampasObj)[0]].corOuImagem}, tamanho: GlobalVar.ordenarTamanhos(estampasObj[Object.keys(estampasObj)[0]].tamanhos.split(","))[0], quantidade: 0}
                })
            
          // Importa dinamicamente quando necessário
          import('../../assets/css/estiloPaginas/produtoPagina.css');
        }
      }, [showStyle, stateInfo.produtoPagina]);

      useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

        return <div className="produtoPagina prodCard">
                                <div className='fotoProd'
                                style={{background: `${bg} no-repeat center/contain`}}>
                                        <div className="botaoVoltar" onClick={()=>dispachInfo({type: 'telaAtual', value: 1})}></div>
                                </div>
                                <div className="infoCard">
                                    <div className="prodTitulo" >{prod.prod_titulo.concat(" - ", prod.rev_nom)}{" . PAG.:"+ prod.pagina}</div>
                                    <div className="prodRef">Ref.: {prod.cod_ref}</div>
                                    <div className="prodPreco">R$ {GlobalVar.converteFloat(parseFloat(prod.produto_preco))}</div>   
                                    <div className="colorCircles">
                                    {stateInfo.produtoPaginaSelectedInfo.color && estampasOrdenadas.map((item) => (
                                        item.label == 'VARIACAO' ? <></> : <ColorCircle item={item} bg={bg} dispachInfo={dispachInfo} stateInfo={stateInfo}/>
                                        ))}
                                    </div>
                                    {/* <div className="prodForn">{prod.for_nomfant}</div> */}

                                    {stateInfo.produtoPaginaSelectedInfo.color ? <>
                                    <div className="tamanhoList">
                                         {estampasObj[stateInfo.produtoPaginaSelectedInfo.color.label] ? GlobalVar.ordenarTamanhos(estampasObj[stateInfo.produtoPaginaSelectedInfo.color.label].tamanhos.split(",")).map(tam =>{
                                            return <div className={`tamanhoCard ${stateInfo.produtoPaginaSelectedInfo.tamanho == tam ? 'selected' : ''}`}
                                            onClick={()=>{
                                                dispachInfo({type: 'produtoPaginaSelectedInfo', value: {...GlobalVar.destructObj(stateInfo.produtoPaginaSelectedInfo), tamanho: tam}})
                                            }}>{tam}</div>
                                        }) 
                                            : <></>}
                                    </div>

                                    <div className="addQuantidade">
                                        <div className="quantidadeBtns">
                                            <div className="circleQtd" onClick={()=>{
                                                            let quantidade = stateInfo.produtoPaginaSelectedInfo.quantidade
                                                            dispachInfo({type: 'produtoPaginaSelectedInfo', value: {...GlobalVar.destructObj(stateInfo.produtoPaginaSelectedInfo), 
                                                                quantidade: quantidade-1 <= 0 ? 0 : quantidade-1}})
                                                        }}>
                                                <div className="menosBtn"></div>
                                            </div>
                                            <input
                                            className="quantidadeTotal"
                                            type="text" inputMode="numeric" pattern="[0-9]*"
                                                value={parseInt(stateInfo.produtoPaginaSelectedInfo.quantidade)}
                                                name="searchTerm"
                                                onChange={(e) => {
                                                    const valor = parseInt(e.target.value, 10)

                                                        dispachInfo({
                                                        type: 'produtoPaginaSelectedInfo',
                                                        value: {
                                                            ...GlobalVar.destructObj(stateInfo.produtoPaginaSelectedInfo),
                                                            quantidade: Number.isNaN(valor) || valor < 0 ? 0 : valor
                                                        }
                                                        })
                                                }}
                                                // onClick={toggle}
                                            />
                                            <div className="circleQtd" onClick={()=>{
                                                    let quantidade = stateInfo.produtoPaginaSelectedInfo.quantidade
                                                    dispachInfo({type: 'produtoPaginaSelectedInfo', value: {...GlobalVar.destructObj(stateInfo.produtoPaginaSelectedInfo), 
                                                        quantidade: quantidade+1}})
                                                }}>
                                                <div className="maisBtn"></div>
                                            </div>
                                        </div>
                                        <div className="addCart"
                                        onClick={()=>{
                                            const produtoAtual = stateInfo.produtoPaginaSelectedInfo
                                            if(produtoAtual.quantidade != 0){
                                                const sacola = GlobalVar.destructObj(stateInfo.produtosSacola)
                                                sacola[`${prod.cod_ref} |||| ${produtoAtual.tamanho} |||| ${produtoAtual.color.label}`] = {
                                                    cod_forn: prod.cod_forn,
                                                    ref: prod.cod_ref,
                                                    descricao: `${prod.prod_titulo.concat(" - ", prod.rev_nom)}${" . PAG.:"+ prod.pagina}`,
                                                    preco: parseFloat(prod.produto_preco),
                                                    tamanho: produtoAtual.tamanho,
                                                    cor: produtoAtual.color.label,
                                                    hex: produtoAtual.color.hex,
                                                    quantidade: produtoAtual.quantidade
                                                }
                                                    
                                                dispachInfo({type: 'produtosSacola', value: sacola})
                                                Swal.fire({
                                                    icon: 'success',
                                                    title: 'Produto Adicionado a Sacola',
                                                    timer: 1000
                                                })
                                                dispachInfo({type: 'produtoPaginaSelectedInfo', 
                                                      value: {color: {label: Object.keys(estampasObj)[0], hex: estampasObj[Object.keys(estampasObj)[0]].corOuImagem}, 
                                                      tamanho: GlobalVar.ordenarTamanhos(estampasObj[Object.keys(estampasObj)[0]].tamanhos.split(","))[0], 
                                                      quantidade: 0}
                                                          })
                                            }
                                        }}>Adicionar Carrinho</div>
                                    </div>

                                    </> : <></>}
                                </div>
        </div> 
}



function parseTamanhosEstampasToObject(tamanhosEstampas) {
    if (!tamanhosEstampas) return {}
  
    return tamanhosEstampas
      .split(' | ')
      .reduce((acc, item) => {
        const [info, valor] = item.split(':')
        const [label, corOuImagem] = info.split(' || ')
  
        acc[label] = {
          label,
          corOuImagem,
          tamanhos: valor,
          raw: item,
          isCorDaFoto: label === 'Cor da Foto',
          isHexColor: /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(corOuImagem),
        }
  
        return acc
      }, {})
  }

  function ordenarEstampasObject(estampasObj) {
    return Object.values(estampasObj).sort((a, b) => {
      if (a.isCorDaFoto && !b.isCorDaFoto) return -1
      if (!a.isCorDaFoto && b.isCorDaFoto) return 1
      return 0
    })
  }
  